export default __webpack_public_path__ + "static/media/IconDesc_Dbl_Ramp_8x8x2_01.256.68c4b42e.png";